import React, { useState, useEffect, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Table,
  FormText,
  Collapse,
  Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, CardHeader

} from "reactstrap";
import RemarkPage from '../../constants/RemarkPage';
import { useSelector } from 'react-redux';
import Item from './Item';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';
import CustomerAddHelperMaster from '../../CustomModal/CustomerAddHelperMaster';
import { allowOnlyNumberAndDot, allowOnlyNumberAndDotOnPaste, calcAngleWeightKg, calcBeamWeightKg_Approx, calcBeamWeightKg_Rect, K, parseLength } from '../../utils/helperFuncation';
import CkEditor from '../../constants/CkEditor';
import MultipleImageUpload from '../../components/ItemMasterComponent/MultipleImageUpload';
import { initialItemValue, initialItemValueSuperAdmin } from '../../utils/RegisterMasterKeyword/ItemKeyword';
import { useMasterRegistry } from '../../hooks/useMasterRegistry';
const API_URL = process.env.REACT_APP_API_BASE_URL;


const AddItem = (props) => {


  const [editorLoaded, setEditorLoaded] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const initial = {
    item_short_name: "",
    item_name: "",
    group: "General",
    group_id: 1,
    hsn_code: "",
    tax_per: '0',
    convertion_of_pcs: "",
    price_purchase_rate: 0,
    price_value_per_pcs: 0,
    price_avg_weight_per_pcs: 0,
    price_opening_stock_rate: 0,
    opening_stock_shop: 0,
    stock_shop: 0,
    opening_stock_godown: 0,
    stock_godown: 0,
    total_stock: 0,
    item_type: "finished",
    item_packing_type: "box",


    price_purchase_packing_cost: 0,
    price_purchase_packing_cost_incl_yn: '',

    price_purchase_discount_percentage: 0,
    price_purchase_discount_amt: 0,
    price_purchase_margin_profit_percentage: 0,
    price_purchase_margin_profit_amount: 0,
    price_purchase_rate_approx: 0,
    price_purchase_amount_after_discount: 0,
    price_purchase_amount_with_packing_cost: 0,
    price_purchase_gst_percentage: 0,
    price_purchase_gst_amount: 0,
    price_purchase_amount_with_gst: 0,

    price_sell_rate: 0,
    price_sell_discount_percentage: 0,
    price_sell_discount_amount: 0,
    price_sell_amount_after_discount: 0,
    price_sell_gst_percentage: 0,
    price_sell_gst_amount: 0,
    price_sell_amount_with_gst: 0,
    purchase_unit_name: "",
    purchase_unit_qty: 0,
    sale_unit_name: "",
    item_barcode_no: "",
    item_remark_no: "",
    item_min_qty: 1,
    item_reorder_qty: 0,
    item_max_qty: 1,
    item_stock_value: 0,

    item_show_website: "",
    item_chargeable_option: "",

    item_branch_vendor_id: null,
    item_branch_master_id: null
  };

  const errorInitial = {
    item_short_name: "",
    item_name: "",
    group: "",
    group_id: null,
    hsn_code: "",
    tax_per: '0',
    convertion_of_pcs: "",
    price_purchase_rate: 0,
    price_value_per_pcs: 0,
    price_avg_weight_per_pcs: 0,
    price_opening_stock_rate: 0,
    opening_stock_shop: 0,
    stock_shop: 0,
    opening_stock_godown: 0,
    stock_godown: 0,
    total_stock: 0,
    item_type: "",
    item_packing_type: "",


    price_purchase_packing_cost: 0,
    price_purchase_packing_cost_incl_yn: '',

    price_purchase_discount_percentage: 0,
    price_purchase_discount_amt: 0,
    price_purchase_margin_profit_percentage: 0,
    price_purchase_margin_profit_amount: 0,
    price_purchase_rate_approx: 0,
    price_purchase_amount_after_discount: 0,
    price_purchase_amount_with_packing_cost: 0,
    price_purchase_gst_percentage: 0,
    price_purchase_gst_amount: 0,
    price_purchase_amount_with_gst: 0,

    price_sell_rate: 0,
    price_sell_discount_percentage: 0,
    price_sell_discount_amount: 0,
    price_sell_amount_after_discount: 0,
    price_sell_gst_percentage: 0,
    price_sell_gst_amount: 0,
    price_sell_amount_with_gst: 0,
    purchase_unit_name: "",
    purchase_unit_qty: 0,
    sale_unit_name: "",
    item_barcode_no: "",
    item_remark_no: "",
    item_min_qty: 1,
    item_reorder_qty: 0,
    item_max_qty: 1,
    item_stock_value: 0,
  };

  const productImageRef = useRef(null)
  const [previewImage, setPreviewImage] = useState(null);


  const [isTabEnabled, setIsTabEnabled] = useState(true);
  const [errorMessage, setErrorMessage] = useState(errorInitial);
  const [categoryTable, setCategoryTable] = useState([]);
  const [itemData, setItemData] = useState(initial);
  const [itemTranxMixDetail, setItemTranxMixDetail] = useState([{
    id: null,
    item_type: "",
    item_name: "",
    item_qty: 1,
    item_rate: 0,
  }])
  const [editMode, setEditMode] = useState(false)
  const [removeItemTransDeleteArray, setRemoveItemTransDeleteArray] = useState([]);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [helperMasterTable, sethelperMasterTable] = useState([]);
  const [itemTable, setItemTable] = useState([]);
  const [helperMasterItemTypeTable, setHelperMasterItemTypeTable] = useState([]);
  const [helperMasterItemPackingTypeTable, setHelperMasterItemPackingTypeTable] = useState([]);
  const [helperMasterItemUnitTable, setHelperMasterItemUnitTable] = useState([])

  const [helperMasterLocation, setHelperMasterLocation] = useState([]);
  const [helperMasterDocumentTypeTable, setHelperMasterDocumentTypeTable] = useState([])
  const [accessButton, setAccessButton] = useState(false);


  const [remarkPageArrayList, setremarkPageArrayList] = useState([])
  const [deleteRemarkPageArrayList, setDeleteRemarkPageArrayList] = useState([])

  const [itemMulImgArrayList, setItemMulImgArrayList] = useState([])
  const [deleteItemMulImgArrayList, setDeleteItemMulImgArrayList] = useState([])

  const [helperMasterSingleItemWarrantyPeriod, setHelperMasterSingleItemWarrantyPeriod] = useState([])
  const [lastItemId, setLastItemId] = useState("")
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);
  const { user } = useSelector((state) => state.authState);
  const [helperMasterItemClassificationTable, setHelperMasterItemClassificationTable] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [registerMasterField, setRegisterMasterField] = useState(initialItemValue);

  const onCancel = () => {
    if (props && typeof props.onCancel === 'function') {
      props.onCancel()
    }
  }


  useMasterRegistry({
    masterName: "item",
    user,
    setState: setRegisterMasterField,
    superAdminDefaults: initialItemValueSuperAdmin
  });


  useEffect(() => {
    console.log(props, "props data ")
    if (props && props.saleMethod == 'group_type') {
      // props.onCancel()
      getItemDataByItemId(props.itemId)
      setEditMode(true)
    }
  }, [props.saleMethod])

  const onHandleBackItem = () => {
    navigate(-1)
  }

  const onChangeHandle = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {

      if (files && files.length > 0 && files[0] instanceof Blob) {

        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };

        reader.readAsDataURL(files[0]);
        setItemData((prevData) => ({
          ...prevData,
          [name]: files[0],
        }));
      }

      return;
    }
    else {

      if (name == "item_name") {

        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          party_company_name: value,
        }));

        if (!editMode) {
          setItemData((prevData) => ({
            ...prevData,
            item_short_name: value
              .split(' ')
              .map(word => word.charAt(0).toUpperCase())
              .join('') + lastItemId
          }));
        }

      } else if (name === "opening_stock_shop") {
        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          total_stock: parseFloat(value) + parseFloat(itemData.opening_stock_godown || 0)
        }));
      } else if (name === "opening_stock_godown") {
        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          total_stock: parseFloat(value) + parseFloat(itemData.opening_stock_shop || 0)
        }));

      } else if (name == "sale_unit_name") {

        let array = helperMasterItemUnitTable.find(e => e.field_name == value);
        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          "convertion_of_pcs": array?.field_data ? array?.field_data : ""
        }));

      } else if (name == "purchase_unit_name") {

        let array = helperMasterItemUnitTable.find(e => e.field_name == value);
        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          "purchase_unit_qty": array?.field_data ? array?.field_data : ""
        }));

      } else if (name == "tax_per") {

        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
          price_sell_gst_percentage: value,
          price_purchase_gst_percentage: value
        }));

      } else if (name == "group") {

        const selectedOption = e.target.options[e.target.selectedIndex];
        const id = selectedOption.getAttribute('data-id');
        const categoryName = selectedOption.value;

        setItemData((prevData) => ({
          ...prevData,
          [name]: categoryName,
          group_id: id ? parseInt(id) : null
        }));
      }
      else if (name === "weight_kg_per_meter") {
        let updatedValues = {
          weight_kg_per_meter: value,
          weight_kg_per_6meter: Math.round(Math.abs(value * 6) * 100) / 100,
          weight_kg_per_12meter: Math.round(Math.abs(value * 12) * 100) / 100,
        };
        // Update itemData state
        setItemData((prev) => ({
          ...prev,
          ...updatedValues,
        }));

      } else if (name === "weight_kg_per_6meter") {
        const perMeter = value / 6;
        let updatedValues = {
          weight_kg_per_6meter: value,
          weight_kg_per_meter: Math.round(Math.abs(perMeter) * 100) / 100,
          weight_kg_per_12meter: Math.round(Math.abs(perMeter * 12) * 100) / 100,
        };

        // Update itemData state
        setItemData((prev) => ({
          ...prev,
          ...updatedValues,
        }));

      } else if (name === "weight_kg_per_12meter") {
        const perMeter = value / 12;
        let updatedValues = {
          weight_kg_per_12meter: value,
          weight_kg_per_meter: Math.round(Math.abs(perMeter) * 100) / 100,
          weight_kg_per_6meter: Math.round(Math.abs(perMeter * 6) * 100) / 100,
        };

        // Update itemData state
        setItemData((prev) => ({
          ...prev,
          ...updatedValues,
        }));
      }


      else {
        setItemData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    }

    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };


  const toggleTab = (event) => {
    const selectedValue = event.target.value;
    setIsTabEnabled(selectedValue);
    toggleAccordion(1); // Assuming toggleAccordion function exists
  };

  const getCategoryData = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get("/api/CategoryMaster/allcategory?pageNo=1&limit=4000", config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCategoryTable(response.categoryMasterDetailData)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getItemData = async (page = 1, limit = 100000, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };


      let url = `/api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`
      if (location.state?.itemId) {
        url += `&flagId=${location.state.itemId}`;
      }

      const response = await apiService.get(url, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setItemTable(response.itemMasterDetailData)
        // setAccessButton(response?.canAccessData)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getLastItemById = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/ItemMaster/itemId`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setLastItemId(response.lastId + 1)
        // setErrorMessage("")
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }


  // const getHelperMaster = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       if (formName === "item_tax-per") {
  //         sethelperMasterTable(response.helperMasterData)
  //       }

  //       if (formName == "issue_challan_warranty_period") {
  //         setHelperMasterSingleItemWarrantyPeriod(response.helperMasterData)
  //       }

  //       if (formName == "item_classification") {
  //         setHelperMasterItemClassificationTable(response.helperMasterData)
  //       }
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // const getItemPackingTypeHelperMaster = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setHelperMasterItemPackingTypeTable(response.helperMasterData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // const getItemTypeHelperMaster = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setHelperMasterItemTypeTable(response.helperMasterData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }


  // const getItemUnitHelperMaster = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setHelperMasterItemUnitTable(response.helperMasterData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }



  // const getHelperDocumentTypeMaster = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setHelperMasterDocumentTypeTable(response.helperMasterData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // const getHelperMasterLocation = async (formName) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setHelperMasterLocation(response.helperMasterData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }


  const getHelperMasterData = async (formName) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config);

      if (response?.response?.data?.errors) {
        toast.success(response.response.data.errors);
        return;
      }

      if (response?.status === true) {
        return response.helperMasterData
        // setStateCallback(response.helperMasterData);
      } else {
        toast.success(response?.message || "Unknown error occurred");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!!");
    }
  };

  const [helperMasterWorkBussinessTable, setHelperMasterWorkBussinessTable] = useState([]);

  // const getHelperMasterData = async (formName, setStateCallback) => {
  //     try {
  //         const config = {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //                 'accept': 'application/json'
  //             }
  //         };

  //         const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config);

  //         if (response?.response?.data?.errors) {
  //             toast.success(response.response.data.errors);
  //             return;
  //         }

  //         if (response?.status === true) {
  //             setStateCallback(response.helperMasterData);
  //         } else {
  //             toast.success(response?.message || "Unknown error occurred");
  //         }
  //     } catch (error) {
  //         console.log(error);
  //         toast.error("Something went wrong!!");
  //     }
  // };

  // useEffect(() => {
  //     getHelperMasterData("working_bussinesss_mode", setHelperMasterWorkBussinessTable);
  // }, []);

  useEffect(() => {
    getItemData();
    getLastItemById();
    setItemData((prevData) => ({
      ...prevData,
      purchase_unit_name: "pcs",
      purchase_unit_qty: "1",
      convertion_of_pcs: "1",
      sale_unit_name: "pcs"
    }));
  }, [!itemTable]);

  // useEffect(() => {
  //   getCategoryData();
  //   getHelperMasterData("item_tax-per", sethelperMasterTable);
  //   getHelperMasterData("item_classification", setHelperMasterItemClassificationTable);
  //   getHelperMasterData("issue_challan_warranty_period", setHelperMasterSingleItemWarrantyPeriod);
  //   getHelperMasterData("item_packing_type", setHelperMasterItemPackingTypeTable);
  //   getHelperMasterData("item_master_item_code", setHelperMasterItemTypeTable);
  //   getHelperMasterData("item_unit", setHelperMasterItemUnitTable);
  //   getHelperMasterData("location_details_for_item_master", setHelperMasterLocation);
  //   getHelperMasterData("remark_detail_document_item", setHelperMasterDocumentTypeTable);
  // }, []);


  const fetchAllData = async () => {
    try {

      // Call all helper data in parallel
      const [
        taxPerData,
        classificationData,
        warrantyPeriodData,
        packingTypeData,
        itemCodeData,
        itemUnitData,
        locationData,
        remarkDocData,
        workingBusiness
      ] = await Promise.allSettled([
        getHelperMasterData("item_tax-per"),
        getHelperMasterData("item_classification"),
        getHelperMasterData("issue_challan_warranty_period"),
        getHelperMasterData("item_packing_type"),
        getHelperMasterData("item_master_item_code"),
        getHelperMasterData("item_unit"),
        getHelperMasterData("location_details_for_item_master"),
        getHelperMasterData("remark_detail_document_item"),
        getHelperMasterData("working_bussinesss_mode")

      ]);

      // Update all state variables with the returned data
      sethelperMasterTable(taxPerData.value || []);
      setHelperMasterItemClassificationTable(classificationData.value || []);
      setHelperMasterSingleItemWarrantyPeriod(warrantyPeriodData.value || []);
      setHelperMasterItemPackingTypeTable(packingTypeData.value || []);
      setHelperMasterItemTypeTable(itemCodeData.value || []);
      setHelperMasterItemUnitTable(itemUnitData.value || []);
      setHelperMasterLocation(locationData.value || []);
      setHelperMasterDocumentTypeTable(remarkDocData.value || []);
      setHelperMasterWorkBussinessTable(workingBusiness.value || []);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getCategoryData();
    fetchAllData();
  }, []);

  const validateInputs = () => {
    const errors = {};

    if (!itemData.item_branch_vendor_id) {
      errors.item_branch_vendor_id = "Vender Name is required"
    }


    if (!itemData.item_branch_master_id) {
      errors.item_branch_master_id = "Branch Name is required"
    }

    if (!itemData.item_name) {
      errors.item_name = 'Item Name is required';
    }
    // if (!itemData.item_short_name) {
    //   errors.item_short_name = 'Item Code is required';
    // }

    if (!itemData.group) {
      errors.group = 'Group is required';
    }

    if (!itemData.item_type) {
      errors.item_type = 'Process Type is required';
    }

    if (!itemData.item_packing_type) {
      errors.item_packing_type = 'Packing Type is required';
    }


    return errors;
  };


  async function uploadImagesFromArrayWithIndex(params) {

    // --- Upload for Remark_Upload_Detail_Key ---
    if (Array.isArray(params.Remark_Upload_Detail_Key) && params.Remark_Upload_Detail_Key.length > 0) {

      for (let i = 0; i < params.Remark_Upload_Detail_Key.length; i++) {

        let obj = params.Remark_Upload_Detail_Key[i];

        if (
          obj.upload_document_path &&
          typeof obj.upload_document_path === "object" &&
          "name" in obj.upload_document_path
        ) {
          try {
            const imageUrl = await uploadImage(obj.upload_document_path);
            obj.upload_document_path = imageUrl;
          } catch (error) {
            console.error("Error uploading remark image:", error);
          }
        }
      }
    }

    // --- Upload for single item_image ---
    if (
      params.item_image &&
      typeof params.item_image === "object" &&
      "name" in params.item_image
    ) {
      try {
        const imageUrl = await uploadImage(params.item_image);
        params.item_image = imageUrl;
      } catch (error) {
        console.error("Error uploading item image:", error);
      }
    }


    // --- Upload for Remark_Upload_Detail_Key ---
    if (Array.isArray(params.Item_Mul_Image_Add_Key) && params.Item_Mul_Image_Add_Key.length > 0) {

      for (let i = 0; i < params.Item_Mul_Image_Add_Key.length; i++) {

        let obj = params.Item_Mul_Image_Add_Key[i];

        if (
          obj.img_url &&
          typeof obj.img_url === "object" &&
          "name" in obj.img_url
        ) {
          try {
            const imageUrl = await uploadImage(obj.img_url);
            obj.img_url = imageUrl;
          } catch (error) {
            console.error("Error uploading remark image:", error);
          }
        }
      }
    }
  }


  async function uploadImage(image) {
    const uploadData = new FormData();
    uploadData.append('signature', image);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'accept': 'application/json'
      }
    };

    try {
      const response = await apiService.post("/api/CommonMaster/uploadfile", uploadData, config);
      if (response.status === true) {
        return response.data;
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      throw new Error("Failed to upload image: " + error.message);
    }
  }

  const AddItemData = async () => {

    if (isSubmitting) {
      // If already submitting, do nothing
      return;
    }

    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    }

    try {

      let params = {
        ...itemData,
        itemTransMixDetailKey: itemTranxMixDetail,
        itemTransStockDetailKey: stockDetailArray,
        Remark_Upload_Detail_Key: remarkPageArrayList,
        Remove_Remark_Upload_Detail_Key: deleteRemarkPageArrayList,
        Item_Mul_Image_Add_Key: itemMulImgArrayList

      }

      await uploadImagesFromArrayWithIndex(params)


      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };


      const response = await apiService.post(`/api/ItemMaster/create`, params, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        // setItemData(initial);
        // setItemTranxMixDetail([{
        //   id: null,
        //   item_name: "",
        //   item_qty: 0,
        //   item_rate: 0,
        // }])

        if (props && typeof props.onInsert === 'function') {
          props?.onInsert()
        }
        // else {
        //   navigate('/item')
        // }
        getItemDataByItemId(response.itemMasterDetailByID.id)
        setEditMode(true)

      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const onHandleItemTanxMixChange = (e, index) => {
    const { name, value } = e.target;



    if (name == "item_name") {
      const list = [...itemTranxMixDetail];
      console.log(value, 'value data ')

      let findArray = itemTable.find((data) => data.item_name == value)

      list[index][name] = value;
      list[index]["item_rate"] = findArray.price_sell_rate


      setItemTranxMixDetail(list);
    } else {
      const list = [...itemTranxMixDetail];
      list[index][name] = value;
      setItemTranxMixDetail(list);
    }



  };




  const handleAddRow = () => {
    setItemTranxMixDetail(prevState => [...prevState, {
      id: null,
      item_name: "",
      item_qty: 1,
      item_rate: 0,
    }]);
  }

  const handleAddressRemoveRow = (index) => {
    const list = [...itemTranxMixDetail];
    const removedItem = list.splice(index, 1)[0];
    setItemTranxMixDetail(list);
    setRemoveItemTransDeleteArray([...removeItemTransDeleteArray, removedItem]);
  };


  const updateItemData = async () => {


    if (isSubmitting) {
      // If already submitting, do nothing
      return;
    }

    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    }
    try {

      let params = {
        ...itemData,
        itemTransMixDetailKey: itemTranxMixDetail,
        itemTransMixDetailDeleteKey: removeItemTransDeleteArray,
        itemTransStockDetailKey: stockDetailArray,
        itemTransStockDetailDeleteKey: removestockDetailDeleteArray,

        Remark_Upload_Detail_Key: remarkPageArrayList,
        Remove_Remark_Upload_Detail_Key: deleteRemarkPageArrayList,

        Item_Mul_Image_Add_Key: itemMulImgArrayList,
        Item_Mul_Image_Delete_Key: deleteItemMulImgArrayList
      }

      await uploadImagesFromArrayWithIndex(params)

      // await uploadImagesFromArrayWithIndex(remarkPageArrayList)

      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };



      const response = await apiService.put(
        `/api/ItemMaster/update?itemId=${itemData.id}`,
        params,
        config
      );

      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);;
      }

      if (response.status === true) {
        toast.success(response.message);

        if (props && typeof props.onInsert === 'function') {
          props?.onInsert()
        }
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  const getItemDataByItemId = async (itemId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/ItemMaster/itemDetailById?itemId=${itemId}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setItemData(response?.itemMasterDetailByID)
        setAccessButton(response?.canAccessData)

        setPreviewImage(API_URL + response?.itemMasterDetailByID?.item_image)


        if (response?.itemMasterDetailByID.itemTransMixDetail.length != 0) {
          setIsTabEnabled('yes')
        }

        if (response?.itemMasterDetailByID.itemTransMixDetail.length != 0) {
          setItemTranxMixDetail(response?.itemMasterDetailByID.itemTransMixDetail)
        } else {
          setItemTranxMixDetail([{
            id: null,
            item_type: "",
            item_name: "",
            item_qty: 0,
            item_rate: 0,
          }])
        }

        setStockDetailArray(response?.itemMasterDetailByID.itemTransStockDetail)
        setremarkPageArrayList(response.itemMasterDetailByID.remark_Upload_Detail)

        const itemTotalQty = response?.itemMasterDetailByID?.itemTransStockDetail.reduce((acc, item) =>
          acc + (parseFloat(item.item_stock_qty || 0)),
          0);

        setItemData((prevData) => ({
          ...prevData,
          item_stock_value: itemTotalQty
        }));

        if (response?.itemMasterDetailByID.itemMultImgTrax.length != 0) {
          setItemMulImgArrayList(response?.itemMasterDetailByID.itemMultImgTrax)
        }




      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }

  useEffect(() => {

    if (props && typeof props.onCancel === 'function') {
      return
    }
    if (location.state) {
      getItemDataByItemId(location.state.itemId)
      setEditMode(true)
    }
  }, [location.state])


  const toggleAccordion = (index) => {
    setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
  };

  // calculation in purchase detail  
  //uue
  useEffect(() => {

    let puchaseRate = parseFloat(itemData.price_purchase_rate || 0);
    let discountPercentage = parseFloat(itemData.price_purchase_discount_percentage || 0);
    let discountAmount = (puchaseRate * discountPercentage) / 100
    let itemPackingCost = parseFloat(itemData.price_purchase_packing_cost || 0)


    // packing cost add in a amount after discount 
    let finalAmountAfterDiscount = (parseFloat(puchaseRate) - parseFloat(discountAmount))
    let amountWithPackingCost = finalAmountAfterDiscount + (itemData.price_purchase_packing_cost_incl_yn === "yes" ? itemPackingCost : 0);


    // gst percenatage
    let gstPercentage = parseFloat(itemData.price_purchase_gst_percentage || 0)
    let gstAmount = amountWithPackingCost * (gstPercentage / 100)
    let amountWithGst = amountWithPackingCost + gstAmount

    // margin percentage
    let marginPercentage = parseFloat(itemData.price_purchase_margin_profit_percentage || 0)
    let marginAmount = amountWithGst * (marginPercentage / 100)

    const purchasePriceApprox = (amountWithGst + parseFloat(marginAmount || 0));


    setItemData((prevState) => ({
      ...prevState,
      price_purchase_discount_amt: discountAmount,
      price_purchase_amount_after_discount: finalAmountAfterDiscount,

      price_purchase_amount_with_packing_cost: amountWithPackingCost,

      price_purchase_gst_amount: gstAmount,
      price_purchase_amount_with_gst: amountWithGst,

      price_purchase_margin_profit_amount: marginAmount,
      price_purchase_rate_approx: purchasePriceApprox,

    }));

  }, [itemData.price_purchase_rate, itemData.price_purchase_discount_percentage,
  itemData.price_purchase_margin_profit_percentage
    , itemData.price_purchase_packing_cost,
  itemData.price_purchase_packing_cost_incl_yn,
  itemData.price_purchase_gst_percentage,

  itemData.price_purchase_discount_amt,

  ]);


  useEffect(() => {
    if (user.user_profile == "superadmin") {
      setAccessButton(true);
    }
  }, [])

  // calculation in sell detail  
  useEffect(() => {

    let sellRate = parseFloat(itemData.price_sell_rate || 0);
    let discountPercentage = parseFloat(itemData.price_sell_discount_percentage || 0);
    let discountAmount = (sellRate * discountPercentage) / 100;

    let finalAmountAfterDiscount = (parseFloat(sellRate) - parseFloat(discountAmount))

    // gst percentage
    let gstPercentage = parseFloat(itemData.price_sell_gst_percentage || 0)
    let gstAmount = finalAmountAfterDiscount * (gstPercentage / 100)

    const salePriceApprox = (finalAmountAfterDiscount + parseFloat(gstAmount || 0));
    setItemData((prevState) => ({
      ...prevState,
      price_sell_discount_amount: discountAmount,
      price_sell_amount_after_discount: finalAmountAfterDiscount,
      price_sell_gst_amount: gstAmount,
      price_sell_amount_with_gst: salePriceApprox
    }));

  }, [
    itemData.price_sell_rate, itemData.price_sell_discount_percentage,
    itemData.price_sell_gst_percentage
  ])


  // this code used for  vender code and   hotel code 

  const getBranchVendorName = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.CompanyMasterMasterData)
        // setVenderMasterTable(response.venderMasterData)

        if (response.venderMasterData.length == 1 && response.venderMasterData) {
          setVenderMasterTable(response.venderMasterData)
          setItemData((prevDetails) => ({
            ...prevDetails,
            item_branch_vendor_id: response.venderMasterData[0].id,
          }));

        }
        else {
          setVenderMasterTable(response.venderMasterData)
        }
        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
    finally {
      setPageLoading(prev => ({ ...prev, vender: false }));
    }
  };

  const getBranchMasterData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const filterName = user.user_profile == "superadmin" ? itemData.item_branch_vendor_id : itemData.accessButton ? itemData.item_branch_vendor_id : null;
      // const filterName = itemData.item_branch_vendor_id ? itemData.item_branch_vendor_id : null;
      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }


      const response = await apiService.get(`/api/BranchMaster/all?${queryString}`, config);
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.BranchMasterMasterData)
        // toast.success(response.message);
        if (response.branchMasterData.length == 1 && response.branchMasterData) {

          setBranchMasterTable(response.branchMasterData)
          setItemData((prevDetails) => ({
            ...prevDetails,
            item_branch_master_id: response.branchMasterData[0].id,
          }));

        }



        else {
          setBranchMasterTable(response.branchMasterData)
          // setItemData((prevDetails) => ({
          //   ...prevDetails,
          //   item_branch_master_id: null
          // }));
        }

      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading(prev => ({ ...prev, branch: false }));
    }
  };


  useEffect(() => {
    getBranchVendorName()
    getBranchMasterData()
  }, [itemData?.item_branch_vendor_id])


  //   ==================    this code used for stock detail  code  ===========================

  let initialStockDetail = {
    item_stock_date: null,
    item_stock_location: "Single Point Connectivity",
    item_stock_qty: null,
    item_stock_rate: null,
    item_stock_value: null,

    item_batch_no: "",
    item_style: "",
    item_brand: "",
    item_color: "",
    item_agent: "",
    item_dealer: "",
  }
  const [stockDetailArray, setStockDetailArray] = useState([])
  const [stockDetail, setStockDetail] = useState(initialStockDetail)
  const [removestockDetailDeleteArray, setRemovestockDetailDeleteArray] = useState([])
  const [stockErrorMessage, setStockErrorMessage] = useState({})


  const onChangeStockDetailHandle = (e) => {
    const { name, value } = e.target;

    if (name == "item_stock_branch_location_id") {

      let findArray = branchMaster.find((data) => data.id == value)

      setStockDetail((prevData) => ({
        ...prevData,
        [name]: value,
        item_stock_branch_location: findArray.branch_name
      }));
    } else {
      setStockDetail((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }


  }


  useEffect(() => {

    let stockQty = parseFloat(stockDetail.item_stock_qty || 0)
    let stockRate = parseFloat(stockDetail.item_stock_rate || 0)

    const itemTotalQty = stockDetailArray.reduce((acc, item) =>
      acc + (parseFloat(item.item_stock_qty || 0)),
      0);

    setItemData((prevData) => ({
      ...prevData,
      item_stock_value: itemTotalQty
    }));

    setStockDetail((prevData) => ({
      ...prevData,
      item_stock_value: stockQty * stockRate
    }));
  }, [stockDetail.item_stock_qty, stockDetail.item_stock_rate])



  const validateStockDetail = (stockDetail) => {
    const errors = {}; // Object for field-wise error messages

    // Mandatory fields (always required)
    if (!stockDetail.item_stock_location) {
      errors.item_stock_location = "Item stock location is required.";
    }

    // if (!stockDetail.item_stock_branch_location_id) {
    //   errors.item_stock_branch_location_id = "Item stock branch location is required.";
    // }

    if (!stockDetail.item_stock_date) {
      errors.item_stock_date = "Item stock date is required.";
    }

    // Item stock quantity
    if (!stockDetail.item_stock_qty) {
      errors.item_stock_qty = "Item stock quantity is required.";
    }

    // Item stock rate
    if (!stockDetail.item_stock_rate) {
      errors.item_stock_rate = "Item stock rate is required.";
    }

    // Item stock value
    if (!stockDetail.item_stock_value) {
      errors.item_stock_value = "Item stock value is required.";
    }

    // Conditionally required fields based on system records
    if (registerMasterField?.batch_no === "yes" && !stockDetail.item_batch_no) {
      errors.item_batch_no = "Item batch number is required.";
    }

    if (registerMasterField?.style === "yes" && !stockDetail.item_style) {
      errors.item_style = "Item style is required.";
    }

    if (registerMasterField?.brand === "yes" && !stockDetail.item_brand) {
      errors.item_brand = "Item brand is required.";
    }

    if (registerMasterField?.color === "yes" && !stockDetail.item_color) {
      errors.item_color = "Item color is required.";
    }

    if (registerMasterField?.agent === "yes" && !stockDetail.item_agent) {
      errors.item_agent = "Item agent is required.";
    }

    if (registerMasterField?.dealer === "yes" && !stockDetail.item_dealer) {
      errors.item_dealer = "Item dealer is required.";
    }

    console.log(errors, 'errors')

    // If there are errors, set them and return true (validation failed)
    if (Object.keys(errors).length > 0) {
      setStockErrorMessage(errors); // This assumes you have setStockErrorMessage state
      return true; // validation failed
    }

    // No errors
    setStockErrorMessage({}); // Clear previous errors if any
    return false; // validation passed
  };


  const AddStockDetail = () => {

    const errors = validateStockDetail(stockDetail);
    if (errors) {
      console.log(stockErrorMessage, "stockErrorMessagestockErrorMessage")
      return;
    }



    let findArray = branchMaster.find((data) => data.id == itemData.item_branch_master_id)
    console.log(findArray, "findArrayfindArray")

    // Check if itemData is not empty
    if (Object.keys(stockDetail).length !== 0) {
      setStockDetailArray((prevItems) => [...prevItems, {
        ...stockDetail,
        item_stock_branch_location: findArray.branch_name,
        item_stock_branch_location_id: findArray.id,
        data_mode: "old"
      }]);
      setStockDetail(initialStockDetail);
    }
  };


  const RemoveStockDetail = (indexToRemove) => {


    setStockDetailArray((prevState) => {
      const updatedStockDetailArray = prevState.filter((item, index) => index !== indexToRemove);
      const removedItem = prevState.find((item, index) => index === indexToRemove);

      if (removedItem) {
        setRemovestockDetailDeleteArray((prevDeleteArray) => [...prevDeleteArray, removedItem]);
      }

      return updatedStockDetailArray;
    });
  }

  // useMemo to calculate total stock efficiently
  const totalStock = useMemo(() => {
    return stockDetailArray.reduce((acc, curr) => acc + (curr.item_stock_value || 0), 0);
  }, [stockDetailArray]);

  // useEffect to update itemData only when totalStock changes
  useEffect(() => {
    setItemData((prev) => {
      if (prev.total_stock === totalStock) return prev; // Prevent unnecessary update
      return { ...prev, total_stock: totalStock };
    });
  }, [totalStock]);

  useEffect(() => {
    if (user.user_profile == "superadmin") {
      setAccessButton(true);
    }
  }, [])

  // get system record detail 


  // const Get_System_RecordsData = async (search) => {
  //   if (search == null) {
  //     search = ''
  //   }

  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         accept: 'application/json',
  //       },
  //     };

  //     const response = await apiService.get(
  //       `/api/System_Records/GetSystem_Records?searchItem=${search}`,
  //       config
  //     );

  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);;
  //     }

  //     if (response.status === true) {
  //       setSystem_Records_data(response.data);
  //       // setTotalPage(response.totalPages);
  //     } else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     alert('SomeThing went wrong')
  //   }
  // };

  // const getSystemRecordsWithFlag = async (flag, uiFlag) => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/System_Records/GetSystem_RecordsByIdWithFlag?flag=${flag}`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }


  //     if (response.status === true) {

  //       if (flag == "item_detail") {
  //         setSystem_Records_data(response.system_RecordsDataById)
  //       }
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // useEffect(() => {
  // Get_System_RecordsData();
  // getSystemRecordsWithFlag("item_detail");

  // }, [!registerMasterField]);



  // item delete api 

  const onHandleDeleteItem = async (id) => {

    const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            'accept': 'application/json'
          }
        };

        const response = await apiService.delete(`/api/ItemMaster/delete?itemId=${id}`, config)
        if (response.response && response.response.data.errors) {
          toast.success(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          navigate("/item")
        }
        else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error)
        toast.error(`SomeThing went wrong!!`);
      }
    } else {
      console.log('Deletion canceled.');
    }
  };


  // const goTODeleteModel = (id) => {
  //   navigate("/commonDelete", { state: { itemId: id, flag: "item", } })
  // }

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=item`;
    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  // get state list 

  // const [stateTable, setStateTable] = useState([]);

  // const getState = async () => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`/api/HelperMaster/allState`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setStateTable(response.state_Master)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //      toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // useEffect(() => {
  //   getState()
  // }, [])


  // const [locationTable, setLocationTable] = useState([]);

  // // this fucntion is used for get the state list 
  // const getLocation = async () => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         'accept': 'application/json'
  //       }
  //     };

  //     const response = await apiService.get(`api/LocationMaster/allLocation`, config)
  //     if (response.response && response.response.data.errors) {
  //       toast.success(response.response?.data?.errors);
  //     }

  //     if (response.status === true) {
  //       setLocationTable(response.locationMasterDetailData)
  //     }
  //     else {
  //       toast.success(response.message);
  //     }
  //   } catch (error) {
  //     console.log(error)
  //      toast.error(`SomeThing went wrong!!`);
  //   }
  // }

  // useEffect(() => {
  //   getLocation()
  // }, [])






  const [showErrorModal, setShowErrorModal] = useState(false)

  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });

  useEffect(() => {

    const allApisLoaded = Object.values(pageloading).every(status => status === false);
    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.item_branch_vendor_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.item_branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }
  }, [branchMaster, venderMaster, pageloading]);


  const [showHelperModal, setHelperModal] = useState(false);
  const [fromName, setFromName] = useState("")

  const openHelperModal = (flagname) => {
    setFromName(flagname);
    setHelperModal(true);
  }

  const closedHelperModal = () => {
    setHelperModal(false);
  }

  // Function to fetch helper master data
  const fetchHelperData = async () => {


    if (fromName === "item_tax-per") {
      let taxPerData = await getHelperMasterData("item_tax-per");
      sethelperMasterTable(taxPerData)
    }

    if (fromName === "item_classification") {
      let classificationData = await getHelperMasterData("item_classification");
      setHelperMasterItemClassificationTable(classificationData)
    }

    if (fromName === "issue_challan_warranty_period") {
      let warrantyPeriodData = await getHelperMasterData("issue_challan_warranty_period");
      setHelperMasterSingleItemWarrantyPeriod(warrantyPeriodData)
    }

    if (fromName === "item_packing_type") {
      let packingTypeData = await getHelperMasterData("item_packing_type");
      setHelperMasterItemPackingTypeTable(packingTypeData)
    }

    if (fromName === "item_master_item_code") {
      let itemCodeData = await getHelperMasterData("item_master_item_code");
      console.log(itemCodeData, "item code daat @@@")
      setHelperMasterItemTypeTable(itemCodeData)
    }

    if (fromName === "item_unit") {
      let itemUnitData = await getHelperMasterData("item_unit");
      setHelperMasterItemUnitTable(itemUnitData)
    }

    if (fromName === "location_details_for_item_master") {
      let locationData = await getHelperMasterData("location_details_for_item_master");
      setHelperMasterLocation(locationData)
    }

    if (fromName === "remark_detail_document_item") {
      let remarkDocData = await getHelperMasterData("remark_detail_document_item");
      setHelperMasterDocumentTypeTable(remarkDocData)
    }
  };

  useEffect(() => {
    // Calculate item name + weight
    const { name, weight } = getItemNameAndWeight(
      itemData.group,
      itemData.item_thickness || 0,
      itemData.item_width || 0,
      itemData.item_length || 0
    );

    console.log(weight, name, "weightweightweight")

    if (itemData.item_name) {
      setItemData(prev => ({
        ...prev,
        // item_name: name,
        // item_short_name: name
        //   .split(' ')
        //   .map(word => word.charAt(0).toUpperCase())
        //   .join('') + lastItemId,
        weight_per_pcs: weight

      }));
    } else {
      setItemData(prev => ({
        ...prev,
        item_name: name,
        item_short_name: name
          .split(' ')
          .map(word => word.charAt(0).toUpperCase())
          .join('') + lastItemId,
        weight_per_pcs: weight

      }));
    }


  }, [
    itemData.group,
    itemData.item_thickness,
    itemData.item_width,
    itemData.item_length
  ]);

  function getItemNameAndWeight(category, thickness, width, length) {
    category = category?.toUpperCase();
    let name = "";
    let weight = 0;
    let NewLength = parseLength(length)



    switch (category) {
      case "MS BEAM":
        name = getBeamSize(width, NewLength);
        weight = calcBeamWeightKg_Approx(NewLength, width, thickness);
        break;

      case "MS ANGLE":

        name = getAngleSize(thickness, width, NewLength);
        weight = calcAngleWeightKg(NewLength, width, thickness);
        break;

      // default:
      //   name = `${width}X${length}`;
      //   weight = 0;
      //   break;
    }
    return { name, weight };
  }


  function getBeamSize(width, length) {
    const base = width % 100;
    return `${base}X${base}`;
  }

  function getAngleSize(thickness, width, length) {
    return `${thickness}X${width}X${length}`;
  }

  // =========================================   CK EDITOR CODE   =========================================
  useEffect(() => {
    setEditorLoaded(true);
  }, []);

  useEffect(()=>{
    if(itemData?.kilograms && itemData?.item_bag){
      let totalValue  =  parseFloat(itemData?.item_bag||0)* parseFloat(itemData?.kilograms||0)
      setItemData((prevState)=>(
        {
          ...prevState,
            value : totalValue
        }))
    }else{
        setItemData((prevState)=>(
        {
          ...prevState,
            value : 0
        }))
    }
  },[itemData?.item_bag, itemData?.kilograms])


  if (Object.values(pageloading).some(status => status == true)) {
    return <SpinnerLoader />
  }


  return (
    <>
      <Row>
        <Col>
          <Card className='bg-white pd-10 card-box mb-30'>
            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between toolbar-row sticky-top"
              style={{
                backgroundColor: "white"
              }}>
              <div className="d-flex align-items-center">
                <i className="bi bi-bell mr-2"></i>

                {props && typeof props.onCancel === 'function' ? (
                  "Item Master"
                ) : (
                  editMode ? "Item Master" : "Item Master"
                )}
              </div>

              {/* <p>{itemData.item_branch_vendor_id} {user.vender_master_id}</p> */}

              {(editMode && accessButton) ?
                <Button type="button" className="ml-auto mr-2 " color="success" disabled={isSubmitting}
                  onClick={() => updateItemData()}>
                  <i className="bi bi-save mr-2"></i>
                  Update                </Button>
                :
                (!editMode && <Button type="button" className="ml-auto mr-2 " color="success" disabled={isSubmitting}
                  onClick={() => AddItemData()}>
                  <i className="bi bi-save mr-2"></i>
                  Save
                </Button>)
              }


              {/* {props && typeof props.onCancel === 'function' ? (
                <>
                </>
              ) : (
                editMode &&  itemData.item_branch_vendor_id == user.vender_master_id) && (
                  <>
                    <td>
                      <Button
                        color="danger"
                        className="mr-2"
                        onClick={() => goTODeleteModel(itemData.id)}
                      >
                        <i className="bi bi-trash"></i>
                        <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Delete</p>
                      </Button>
                    </td>
                  </>
                )
              )} */}
              {props && typeof props.onCancel === 'function' ? (
                <></>
              ) : (
                editMode && accessButton && (
                  <td>
                    <Button
                      color="danger"
                      className="mr-2"
                      onClick={() => goTODeleteModel(itemData.id)}
                    >
                      <i className="bi bi-trash mr-2"></i>
                      Delete
                    </Button>
                  </td>
                )
              )}



              {props && typeof props.onCancel === 'function' ?
                <Button
                  color="danger"
                  onClick={onCancel}
                  className=""
                >

                  <i className="bi bi-x-circle mr-2"></i>
                  Cancel
                </Button>



                :
                <Button
                  color="warning"
                  onClick={onHandleBackItem}
                  className="me-0"
                >

                  <i className="bi bi-arrow-left mr-2"></i>                 Back
                </Button>
              }





            </CardTitle>

            <CardBody>
              <Form>
                <Row>

                  {(venderMaster.length === 0 || venderMaster.length > 1) && <Col xl={12} >
                    {<FormGroup>
                      <Label for="item_branch_vendor_id">Vendor Name</Label>
                      <Input className="custom-select"
                        type='select'
                        id="item_branch_vendor_id"
                        name="item_branch_vendor_id"
                        value={itemData.item_branch_vendor_id}
                        onChange={(e) => { onChangeHandle(e) }}
                        disabled={!accessButton}
                      >
                        <option value="">Select</option>
                        {venderMaster.map((option) => (
                          <option key={option.id} value={option.id} data-id={option.id}>
                            {option.vender_name}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.item_branch_vendor_id && (
                        <FormText color="danger">{errorMessage.item_branch_vendor_id}</FormText>
                      )}
                    </FormGroup>}
                  </Col>}


                  {(branchMaster.length === 0 || branchMaster.length > 1) && <Col xl={12}>
                    {<FormGroup>
                      <Label for="item_branch_master_id">Branch name</Label>
                      <Input className="custom-select"
                        type='select'
                        id="item_branch_master_id"
                        name="item_branch_master_id"
                        value={itemData.item_branch_master_id}
                        onChange={(e) => { onChangeHandle(e) }}
                        disabled={!accessButton}

                      >
                        <option value="">Select</option>
                        {branchMaster.map((option) => (
                          <option key={option.id} value={option.id} data-id={option.id}>
                            {option.branch_name}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.item_branch_master_id && (
                        <FormText color="danger">{errorMessage.item_branch_master_id}</FormText>
                      )}
                    </FormGroup>}
                  </Col>}
                </Row>


                {/* item image  */}
                <Row style={{ justifyContent: "center" }}>
                  <Col md="5">
                    <FormGroup>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {
                          previewImage ?
                            <img src={previewImage} style={{
                              width: '100px',
                              height: '100px',
                              borderRadius: '50%',
                              marginBottom: '10px',
                            }} alt="Preview" />
                            :
                            <>
                              <div style={{
                                width: '100px',
                                height: '100px',
                                borderRadius: '50%',
                                backgroundColor: 'lightgray',
                                backgroundImage: 'url("")',
                                backgroundSize: 'cover',
                                marginBottom: '10px',
                              }} className="rounded-circle"></div>
                            </>

                        }
                        <Input className="custom-border d-none"
                          id="item_image"
                          name="item_image"
                          type="file"
                          innerRef={productImageRef}
                          onChange={(e) => { onChangeHandle(e) }}
                        />

                        <label htmlFor="item_image" style={{
                          width: '150px',
                          textAlign: 'center'
                        }} className="upload-button btn btn-primary">
                          Upload Image
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="item_name">Item Name</Label>
                      <Input
                        id="item_name"
                        name="item_name"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_name}
                      />
                      {errorMessage.item_name && (
                        <FormText color="danger">{errorMessage.item_name}</FormText>
                      )}
                    </FormGroup>
                  </Col>


                  <Col md={4}>
                    <FormGroup>
                      <Label for="item_short_name">Item Short Code</Label>
                      <Input
                        id="item_short_name"
                        name="item_short_name"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_short_name}
                      />
                      {errorMessage.item_short_name && (
                        <FormText color="danger">{errorMessage.item_short_name}</FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="group">Group</Label>
                      <Input className="custom-select"
                        id="group"
                        name="group"
                        type="select"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.group}
                      >
                        <option value="">Select</option>
                        {categoryTable.map((data) => (
                          <option key={data.id} value={data.category_name} data-id={data.id}>
                            {data.category_name}
                          </option>
                        ))}
                      </Input>

                      {errorMessage.group && (
                        <FormText color="danger">{errorMessage.group}</FormText>
                      )}
                    </FormGroup>
                  </Col>

                  {registerMasterField?.item_inventory_type_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="inventory_type">Inventory Type</Label>
                      <Input
                        id="inventory_type"
                        name="inventory_type"
                        type="select" className="custom-select"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.inventory_type}
                        style={{ fontSize: 14 }}
                      >
                        <option value="">Select</option>
                        <option value="inventory">Inventory</option>
                        <option value="no_inventory">No Inventory</option>
                      </Input>
                    </FormGroup>
                  </Col>}





                  {registerMasterField?.item_proces_type_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_type">Process Type
                        <i
                          className="fa fa-plus-circle"
                          onClick={() => { openHelperModal("item_master_item_code") }}
                          style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                        ></i>
                      </Label>
                      <Input type="select" className="custom-select"
                        name="item_type"
                        id="item_type"
                        value={itemData.item_type}
                        onChange={(e) => { onChangeHandle(e) }}
                      >
                        <option value="">select</option>
                        {helperMasterItemTypeTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_data}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.item_type && (
                        <FormText color="danger">{errorMessage.item_type}</FormText>
                      )}
                    </FormGroup>
                  </Col>}


                  {registerMasterField?.item_pack_type_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_packing_type">Packing Type
                        <i
                          className="fa fa-plus-circle"
                          onClick={() => { openHelperModal("item_packing_type") }}
                          style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                        ></i>
                      </Label>
                      <Input type="select" className="custom-select"
                        name="item_packing_type"
                        id="item_packing_type"
                        value={itemData.item_packing_type}
                        onChange={(e) => { onChangeHandle(e) }}
                      >
                        <option value="">select</option>
                        {helperMasterItemPackingTypeTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_data}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.item_packing_type && (
                        <FormText color="danger">{errorMessage.item_packing_type}</FormText>
                      )}
                    </FormGroup>
                  </Col>}


                  {registerMasterField?.item_classify_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_classification_id">Item Classification
                        <i
                          className="fa fa-plus-circle"
                          onClick={() => { openHelperModal("item_classification") }}
                          style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                        ></i>

                      </Label>
                      <Input type="select" className="custom-select"
                        name="item_classification_id"
                        id="item_classification_id"
                        value={itemData.item_classification_id}
                        onChange={(e) => { onChangeHandle(e) }}
                      >
                        <option value="">select</option>
                        {helperMasterItemClassificationTable.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>
                      {/* {errorMessage.item_classification_id && (
                        <FormText color="danger">{errorMessage.item_classification_id}</FormText>
                      )} */}
                    </FormGroup>
                  </Col>}





                  {/* <Col>
                    <FormGroup>
                      <Label for="price_avg_weight_per_pcs">Avg Weight Per Pcs</Label>
                      <Input 
                        id="price_avg_weight_per_pcs"
                        name="price_avg_weight_per_pcs"
                        type="number"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.price_avg_weight_per_pcs}
                      />
                      {errorMessage.price_avg_weight_per_pcs && (
                        <FormText color="danger">{errorMessage.price_avg_weight_per_pcs}</FormText>
                      )}
                    </FormGroup>
                  </Col> */}
                  <Col sm={4}>
                    <FormGroup>
                      <Label for="hsn_code">HSN Code</Label>
                      <Input
                        id="hsn_code"
                        name="hsn_code"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.hsn_code}
                      />
                      {errorMessage.hsn_code && (
                        <FormText color="danger">{errorMessage.hsn_code}</FormText>
                      )}
                    </FormGroup>
                  </Col>


                  {registerMasterField?.item_barcode_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_barcode_no">Barcode No</Label>
                      <Input
                        id="item_barcode_no"
                        name="item_barcode_no"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_barcode_no}
                      />

                      {errorMessage.item_barcode_no && (
                        <FormText color="danger">{errorMessage.item_barcode_no}</FormText>
                      )}
                    </FormGroup>
                  </Col>}



                  {registerMasterField?.item_gst_per_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="tax_per">GST Per %</Label>
                      <Input
                        id="tax_per"
                        name="tax_per"
                        type="select" className="custom-select"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.tax_per}
                      >
                        <option value="0">0</option>
                        {helperMasterTable.length != 0 && helperMasterTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}

                      </Input>
                      {/* {errorMessage.tax_per && (
                        <FormText color="danger">{errorMessage.tax_per}</FormText>
                      )} */}
                    </FormGroup>
                  </Col>}


                  {registerMasterField?.item_remark_yn == "yes" && <Col sm={12}>
                    <FormGroup>
                      <Label for="item_remark_no">Remark</Label>
                      <Input
                        id="item_remark_no"
                        name="item_remark_no"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_remark_no}
                      />
                      {errorMessage.item_remark_no && (
                        <FormText color="danger">{errorMessage.item_remark_no}</FormText>
                      )}
                    </FormGroup>
                  </Col>}

                  {registerMasterField?.item_min_qty_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_min_qty">Min Qty</Label>
                      <Input
                        id="item_min_qty"
                        name="item_min_qty"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_min_qty}
                      />
                      {/* {errorMessage.item_min_qty && (
                        <FormText color="danger">{errorMessage.item_min_qty}</FormText>
                      )} */}
                    </FormGroup>
                  </Col>}

                  {registerMasterField?.item_reorder_qty_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_reorder_qty">Reorder Qty</Label>
                      <Input
                        id="item_reorder_qty"
                        name="item_reorder_qty"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_reorder_qty}
                      />
                      {/* {errorMessage.item_reorder_qty && (
                        <FormText color="danger">{errorMessage.item_reorder_qty}</FormText>
                      )} */}
                    </FormGroup>
                  </Col>}

                  {registerMasterField?.item_max_qty_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_max_qty">Max Qty</Label>
                      <Input
                        id="item_max_qty"
                        name="item_max_qty"
                        type="text"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.item_max_qty}
                      />
                      {/* {errorMessage.item_max_qty && (
                        <FormText color="danger">{errorMessage.item_max_qty}</FormText>
                      )} */}
                    </FormGroup>
                  </Col>}


                  {registerMasterField?.item_warnty_available_yn == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="warranty_yes_no">Warranty Available</Label>
                      <Input
                        id="warranty_yes_no"
                        name="warranty_yes_no"
                        type="select" className="custom-select"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.warranty_yes_no}
                        style={{ fontSize: 14 }}
                      >
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </Input>
                    </FormGroup>
                  </Col>}




                  {itemData.warranty_yes_no == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="warranty_period">Warranty Period</Label>
                      <Input
                        id="warranty_period"
                        name="warranty_period"
                        type="select" className="custom-select"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.warranty_period || ""}
                        style={{ fontSize: 14 }}
                      >
                        {/* <option value="">Select</option>
                        <option value="6 Months">6 Months</option>
                        <option value="1 Year">1 Year</option>
                        <option value="2 Year">2 Year</option>
                        <option value="3 Year">3 Year</option> */}

                        <option value="">Select</option>
                        {helperMasterSingleItemWarrantyPeriod.length != 0 && helperMasterSingleItemWarrantyPeriod.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_data}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>}



                  {/* // short_desc */}
                  {/* // long_desc */}

                  {registerMasterField?.item_title == "yes" && <Col sm={12}>
                    <FormGroup>
                      <Label for="short_desc">Item Title</Label>
                      <Input
                        id="short_desc"
                        name="short_desc"
                        type="text"
                        maxLength={94}

                        onChange={(e) => { onChangeHandle(e) }}
                        value={itemData?.short_desc}

                      />

                    </FormGroup>
                  </Col>}

                  {registerMasterField?.item_description == "yes" && <Col sm={12}>
                    <Label for="short_desc">Item Description</Label>

                    <CkEditor
                      name="long_desc"
                      onChange={(data) => {
                        setItemData((prevData) => ({
                          ...prevData,
                          long_desc: data,
                        }));
                      }}
                      editorLoaded={editorLoaded}
                      value={itemData?.long_desc}
                    />
                  </Col>}





                  {/* ==========   purchase invoice  ========  */}



                  {/* item_make */}
                  {registerMasterField?.make == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_make">Make</Label>
                      <Input

                        id="item_make"
                        name="item_make"
                        type="text"
                        placeholder='Enter the Make'

                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.item_make}
                      />
                    </FormGroup>
                  </Col>}

                  {/* item_size */}
                  {/* <Col sm={4}>
                    <FormGroup>
                      <Label for="item_size">Size</Label>
                      <Input
                        
                        id="item_size"
                        name="item_size"
                        type="text"
                        placeholder='0X0'
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.item_size}
                      />
                    </FormGroup>
                  </Col> */}



                  {/* item_width */}
                  {registerMasterField?.width == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_width">Width</Label>
                      <Input

                        id="item_width"
                        name="item_width"
                        type="number"
                        step="0.01"
                        placeholder='0'

                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.item_width}
                      />
                    </FormGroup>
                  </Col>}

                  {/* item_length */}
                  {registerMasterField?.length == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_length">Length</Label>
                      <Input

                        id="item_length"
                        name="item_length"
                        type="text"
                        step="0.01"
                        placeholder='0'
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.item_length}
                      />
                    </FormGroup>
                  </Col>}



                  {/* item_thickness */}
                  {registerMasterField?.thickness == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="item_thickness">Thickness</Label>
                      <Input

                        id="item_thickness"
                        name="item_thickness"
                        type="number"
                        step="0.01"
                        placeholder='0'
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.item_thickness}
                      />
                    </FormGroup>
                  </Col>}


                  {/* weight_kg_per_feet */}
                  {registerMasterField?.weight_per_feet == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="weight_kg_per_feet">Weight (Kg per Feet)</Label>
                      <Input

                        id="weight_kg_per_feet"
                        name="weight_kg_per_feet"
                        type="number"
                        placeholder="Enter weight per feet"
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.weight_kg_per_feet}
                      />
                    </FormGroup>
                  </Col>}

                  {/* weight_kg_per_meter */}
                  {registerMasterField?.weight_per_meter == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="weight_kg_per_meter">Weight (Kg per Meter)</Label>
                      <Input

                        id="weight_kg_per_meter"
                        name="weight_kg_per_meter"
                        type="number"
                        placeholder="Enter weight per meter"
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.weight_kg_per_meter}
                      />
                    </FormGroup>
                  </Col>}

                  {/* weight_kg_per_6meter */}
                  {registerMasterField?.weight_per_6_meter == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="weight_kg_per_6meter">Weight (Kg per 6 Meter)</Label>
                      <Input

                        id="weight_kg_per_6meter"
                        name="weight_kg_per_6meter"
                        type="number"
                        placeholder="Enter weight per 6 meter"
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.weight_kg_per_6meter}
                      />
                    </FormGroup>
                  </Col>}

                  {/* weight_kg_per_12meter */}
                  {registerMasterField?.weight_per_12_meter == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="weight_kg_per_12meter">Weight (Kg per 12 Meter)</Label>
                      <Input

                        id="weight_kg_per_12meter"
                        name="weight_kg_per_12meter"
                        type="number"
                        placeholder="Enter weight per 12 meter"
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.weight_kg_per_12meter}
                      />
                    </FormGroup>
                  </Col>}


                  {registerMasterField?.weight_per_pcs == "yes" && <Col sm={4}>
                    <FormGroup>
                      <Label for="weight_per_pcs">Weight Per Pcs</Label>
                      <Input

                        id="weight_per_pcs"
                        name="weight_per_pcs"
                        type="number"
                        placeholder="Enter Weight Per Pcs"
                        onChange={(e) => onChangeHandle(e)}
                        value={itemData?.weight_per_pcs}
                      />
                    </FormGroup>
                  </Col>}

                </Row>



                {registerMasterField?.item_acc_mixed_yn == "yes" && <Row>
                  <Col sm={3}>
                    <FormGroup>
                      <Label for="">Mix Detail</Label>
                      <Input
                        id="mix_item_yes_no"
                        name="mix_item_yes_no"
                        type="select" className="custom-select"
                        value={itemData.mix_item_yes_no}
                        onChange={(e) => { onChangeHandle(e) }}
                      >
                        {/* <option>select</option> */}
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </Input>

                    </FormGroup>
                  </Col>
                </Row>}



              </Form>
            </CardBody>






            {/* // Mix Detail  */}
            {
              (registerMasterField?.item_acc_mixed_yn == "yes" && itemData.mix_item_yes_no == 'yes')
              &&
              <div>
                <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                  style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}
                  onClick={() => toggleAccordion(1)}
                >
                  <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "orange" }}>
                    <i className="bi bi-bell mr-2"></i>
                    Mix Detail
                  </div>
                  {openAccordion === 1 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}

                </CardTitle>

                <Collapse isOpen={openAccordion === 1}>
                  <CardBody style={{ backgroundColor: "#ebd6af" }}>
                    <>
                      {/* {itemTranxMixDetail.map((item, index) => (
                        <div key={index} style={{ marginBottom: 20, border: "1px solid #dee2e6", padding: 10, borderRadius: 20 }}>
                          <Row>
                            <Col sm={3}>
                              <FormGroup>
                                <Label for="item_name">Item Name:</Label>
                                <Input  type="select"  className="custom-select"
                                  name="item_name"
                                  id="item_name"
                                  value={item.item_name}
                                  onChange={(e) => onHandleItemTanxMixChange(e, index)}
                                  disabled={!isTabEnabled}
                                >
                                  <option value="">select</option>
                                  {itemTable.map((option) => (
                                    <option key={option.id} value={option.item_name}>
                                      {option.item_name}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>

                            <Col sm={3}>
                              <FormGroup>
                                <Label for="item_qty">Item Quantity:</Label>
                                <Input  type="number" name="item_qty" id="item_qty" value={item.item_qty} onChange={(e) => onHandleItemTanxMixChange(e, index)} disabled={!isTabEnabled} />
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup>
                                <Label for="item_rate">Item Rate:</Label>
                                <Input  type="number" name="item_rate" id="item_rate" value={item.item_rate} onChange={(e) => onHandleItemTanxMixChange(e, index)} disabled={!isTabEnabled} />
                              </FormGroup>
                            </Col>

                            <Col xs="4" sm="4" md="2" lg="2">
                              <FormGroup>
                                <Label for="">Action:</Label>
                                <Button
                                  type="button"
                                  color="danger"
                                  onClick={() => handleAddressRemoveRow(index)}
                                  disabled={!isTabEnabled}
                                  block                                 >
                                  Remove
                                </Button>
                              </FormGroup>
                            </Col>

                          </Row>
                        </div>
                      ))} */}


                      {itemTranxMixDetail.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: 20,
                            border: '1px solid #dee2e6',
                            padding: 10,
                            borderRadius: 20,
                            position: 'relative', // Enable positioning of the icon
                          }}
                        >
                          {/* Remove Icon */}
                          <i
                            className="fas fa-times-circle text-danger"
                            style={{
                              position: 'absolute',
                              top: '-10px',
                              right: '10px',
                              fontSize: '30px',
                              cursor: 'pointer',
                            }}
                            onClick={() => handleAddressRemoveRow(index)}
                            disabled={!isTabEnabled}
                          />

                          <Row>
                            <Col sm={4}>
                              <FormGroup>
                                <Label for="item_name">Item Name:</Label>
                                <Input

                                  type="select" className="custom-select"
                                  name="item_name"
                                  id="item_name"
                                  value={item.item_name}
                                  onChange={(e) => onHandleItemTanxMixChange(e, index)}
                                  disabled={!isTabEnabled}
                                >
                                  <option value="">select</option>
                                  {itemTable.map((option) => (
                                    <option key={option.id} value={option.item_name}>
                                      {option.item_name}
                                    </option>
                                  ))}
                                </Input>
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for="item_qty">Item Quantity:</Label>
                                <Input

                                  type="number"
                                  name="item_qty"
                                  id="item_qty"
                                  value={item.item_qty}
                                  onChange={(e) => onHandleItemTanxMixChange(e, index)}
                                  disabled={!isTabEnabled}
                                />
                              </FormGroup>
                            </Col>

                            <Col sm={4}>
                              <FormGroup>
                                <Label for="item_rate">Item Rate:</Label>
                                <Input

                                  type="number"
                                  name="item_rate"
                                  id="item_rate"
                                  value={item.item_rate}
                                  onChange={(e) => onHandleItemTanxMixChange(e, index)}
                                  disabled={!isTabEnabled}
                                />
                              </FormGroup>
                            </Col>

                            {/* <Col xs="4" sm="4" md="2" lg="2">
                              <FormGroup>
                                <Label for="">Action:</Label>
                                <Button
                                  type="button"
                                  color="danger"
                                  onClick={() => handleAddressRemoveRow(index)}
                                  disabled={!isTabEnabled}
                                  block // makes button full-width on smaller screens
                                >
                                  Remove
                                </Button>
                              </FormGroup>
                            </Col> */}
                          </Row>
                        </div>
                      ))}

                      <Button color="primary" onClick={() => { handleAddRow() }} style={{ marginBottom: 20 }} disabled={!isTabEnabled}>Add More</Button>

                    </>

                  </CardBody>
                </Collapse>
              </div>
            }


            {/* // Website Detail  */}
            {registerMasterField?.item_acc_website_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(2)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "rgb(142, 35, 35)" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Website Detail
                </div>
                {openAccordion === 2 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}


              </CardTitle>

              <Collapse isOpen={openAccordion === 2}>
                <CardBody style={{ backgroundColor: "#E6E6FA" }}>
                  <Form>
                    <Row>


                      <Col xl={4}>
                        <FormGroup>
                          <Label for="item_show_website">Show Item In Website</Label>
                          <Input
                            id="item_show_website"
                            name="item_show_website"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.item_show_website}
                            style={{ fontSize: 14 }}
                          >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col xl={4}>
                        <FormGroup>
                          <Label for="item_chargeable_option">Chargeable</Label>
                          <Input
                            id="item_chargeable_option"
                            name="item_chargeable_option"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.item_chargeable_option}
                            style={{ fontSize: 14 }}
                          >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col xl={4}>
                        <FormGroup>
                          <Label for="item_choose_charge_drop">One Time charge In Website</Label>
                          <Input
                            id="item_choose_charge_drop"
                            name="item_choose_charge_drop"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.item_choose_charge_drop}
                            style={{ fontSize: 14 }}
                          >
                            <option value="">Select</option>
                            <option value="per_day">Per Day</option>
                            <option value="one_time">One Time</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col xl={4}>
                        <FormGroup>
                          <Label for="charges_include_in_total_yn">Charges include in total yn</Label>
                          <Input
                            id="charges_include_in_total_yn"
                            name="charges_include_in_total_yn"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.charges_include_in_total_yn}
                            style={{ fontSize: 14 }}
                          >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Collapse>
            </div>}



            {/* // Convertion Detail  */}
            {registerMasterField?.item_acc_convertion_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(3)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "#800080" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Convertion Detail
                </div>
                {openAccordion === 3 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}


              </CardTitle>

              <Collapse isOpen={openAccordion === 3}>
                <CardBody style={{ backgroundColor: "#E6E6FA" }}>
                  <Form>
                    <Row>



                      <Col sm={4}>
                        <FormGroup>
                          <Label for="purchase_unit_name">Purchase Unit Name  <i
                            className="fa fa-plus-circle"
                            onClick={() => { openHelperModal("item_unit") }}
                            style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                          ></i></Label>
                          <Input
                            id="purchase_unit_name"
                            name="purchase_unit_name"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.purchase_unit_name}
                          >
                            <option value="">select</option>
                            {helperMasterItemUnitTable.map((option) => (
                              <option key={option.id} value={option.field_name}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                          {errorMessage.purchase_unit_name && (
                            <FormText color="danger">{errorMessage.purchase_unit_name}</FormText>
                          )}
                        </FormGroup>
                      </Col>





                      <Col sm={4}>
                        <FormGroup>
                          <Label for="purchase_unit_qty">Purchase Unit Qty (Convertion)</Label>
                          <Input
                            id="purchase_unit_qty"
                            name="purchase_unit_qty"
                            type="number"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.purchase_unit_qty}
                          />
                          {/* {errorMessage.purchase_unit_qty && (
                            <FormText color="danger">{errorMessage.purchase_unit_qty}</FormText>
                          )} */}
                        </FormGroup>
                      </Col>


                      <Col sm={4}>
                        <FormGroup>
                          <Label for="avg_weight_of_purchase">Avg. Weight of Purchase</Label>
                          <Input
                            id="avg_weight_of_purchase"
                            name="avg_weight_of_purchase"
                            type="number"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.avg_weight_of_purchase}
                          />
                          {errorMessage.avg_weight_of_purchase && (
                            <FormText color="danger">{errorMessage.avg_weight_of_purchase}</FormText>
                          )}
                        </FormGroup>
                      </Col>


                    </Row>

                    <Row>
                      <Col sm={4}>
                        <FormGroup>
                          <Label for="sale_unit_name"> Sale Unit Name
                            <i
                              className="fa fa-plus-circle"
                              onClick={() => { openHelperModal("item_unit") }}
                              style={{ cursor: 'pointer', marginLeft: '10px', color: "blue", fontSize: 20 }}
                            ></i>
                          </Label>
                          <Input
                            id="sale_unit_name"
                            name="sale_unit_name"
                            type="select" className="custom-select"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.sale_unit_name}
                          >
                            <option value="">select</option>
                            {helperMasterItemUnitTable.map((option) => (
                              <option key={option.id} value={option.field_name}>
                                {option.field_name}
                              </option>
                            ))}
                          </Input>
                          {errorMessage.sale_unit_name && (
                            <FormText color="danger">{errorMessage.sale_unit_name}</FormText>
                          )}
                        </FormGroup>
                      </Col>


                      <Col sm={4}>
                        <FormGroup>
                          <Label for="convertion_of_pcs">Sale Unit Qty (Convertion)</Label>
                          <Input
                            id="convertion_of_pcs"
                            name="convertion_of_pcs"
                            type="number"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.convertion_of_pcs}
                          />
                          {errorMessage.convertion_of_pcs && (
                            <FormText color="danger">{errorMessage.convertion_of_pcs}</FormText>
                          )}
                        </FormGroup>
                      </Col>


                      <Col sm={4}>
                        <FormGroup>
                          <Label for="avg_weight_of_sell">Avg. Weight of Sell</Label>
                          <Input
                            id="avg_weight_of_sell"
                            name="avg_weight_of_sell"
                            type="number"
                            onChange={(e) => { onChangeHandle(e) }}
                            value={itemData?.avg_weight_of_sell}
                          />
                          {errorMessage.avg_weight_of_sell && (
                            <FormText color="danger">{errorMessage.avg_weight_of_sell}</FormText>
                          )}
                        </FormGroup>
                      </Col>


                    </Row>
                  </Form>
                </CardBody>
              </Collapse>
            </div>}


            {/* // Price Detail  */}
            {registerMasterField?.item_acc_price_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(4)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "red" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Price Detail
                </div>

                {openAccordion === 4 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}


              </CardTitle>

              <Collapse isOpen={openAccordion === 4}>
                <CardBody >

                  <div className="App">
                    <Row>


                      {/* <div className="totals" style={{ float: 'left', width: '50%', paddingRight: '10px', overflowY: 'auto', }}> */}
                      <Col xs="12" md="6" className="mb-3">


                        <div style={{ border: "2px solid black", padding: "10px", marginBottom: "10px", borderRadius: "20px", backgroundColor: "rgb(255 194 194)" }}>
                          <h4 style={{ fontWeight: "bold", margin: "10px 0 20px 0", textAlign: "center" }}>Purchase Rate Detail</h4>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_rate" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Purchase Rate</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_rate"
                                name="price_purchase_rate"
                                type="number"
                                min={0}
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_rate}
                              />
                              {/* {errorMessage.price_purchase_rate && (
                              <FormText color="danger">{errorMessage.price_purchase_rate}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>




                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_discount_percentage" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Discount %</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_discount_percentage"
                                name="price_purchase_discount_percentage"
                                type="number"
                                min={0}
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_discount_percentage}
                              />
                              {/* {errorMessage.price_purchase_discount_percentage && (
                              <FormText color="danger">{errorMessage.price_purchase_discount_percentage}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_discount_amt" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Discount Amt</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_discount_amt"
                                name="price_purchase_discount_amt"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_discount_amt}
                                disabled={itemData.price_purchase_discount_percentage != 0}
                              />
                              {/* {errorMessage.price_purchase_discount_amt && (
                              <FormText color="danger">{errorMessage.price_purchase_discount_amt}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_amount_after_discount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Purchase rate after disc</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_amount_after_discount"
                                name="price_purchase_amount_after_discount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_amount_after_discount}
                                disabled

                              />
                              {/* {errorMessage.price_purchase_amount_after_discount && (
                              <FormText color="danger">{errorMessage.price_purchase_amount_after_discount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_packing_cost" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Packing Cost</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_packing_cost"
                                name="price_purchase_packing_cost"
                                type="number"
                                min={0}
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_packing_cost}
                              />

                              {/* {errorMessage.price_purchase_packing_cost && (
                              <FormText color="danger">{errorMessage.price_purchase_packing_cost}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>

                              <Label for="price_purchase_packing_cost_incl_yn" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Include Packing Cost</Label>

                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_packing_cost_incl_yn"
                                name="price_purchase_packing_cost_incl_yn"
                                type="select" className="custom-select"
                                min={0}
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_packing_cost_incl_yn}
                              >
                                <option value="">Select</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>

                              </Input>
                            </FormGroup>
                          </Col>



                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>

                              <Label for="price_purchase_amount_with_packing_cost" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Purchase rate with packing cost</Label>

                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_amount_with_packing_cost"
                                name="price_purchase_amount_with_packing_cost"
                                type="text"
                                min={0}
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_amount_with_packing_cost}
                                disabled
                              />
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_gst_percentage" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>GST %</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_gst_percentage"
                                name="price_purchase_gst_percentage"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_gst_percentage}
                              />
                              {/* {errorMessage.price_purchase_gst_percentage && (
                              <FormText color="danger">{errorMessage.price_purchase_gst_percentage}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_gst_amount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>GST Amt</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_gst_amount"
                                name="price_purchase_gst_amount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_purchase_gst_amount == "number" ? itemData?.price_purchase_gst_amount.toFixed(2) : itemData?.price_purchase_gst_amount}
                                disabled
                              />
                              {/* {errorMessage.price_purchase_gst_amount && (
                              <FormText color="danger">{errorMessage.price_purchase_gst_amount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_amount_with_gst" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Amount with gst </Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_amount_with_gst"
                                name="price_purchase_amount_with_gst"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_purchase_amount_with_gst == "number" ? itemData?.price_purchase_amount_with_gst.toFixed(2) : itemData?.price_purchase_amount_with_gst}
                                disabled
                              />
                              {/* {errorMessage.price_purchase_amount_with_gst && (
                              <FormText color="danger">{errorMessage.price_purchase_amount_with_gst}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>


                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_margin_profit_percentage" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Margin/Profit %</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_margin_profit_percentage"
                                name="price_purchase_margin_profit_percentage"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_purchase_margin_profit_percentage}
                              />
                              {/* {errorMessage.price_purchase_margin_profit_percentage && (
                              <FormText color="danger">{errorMessage.price_purchase_margin_profit_percentage}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_margin_profit_amount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Margin/Profit Amt</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_margin_profit_amount"
                                name="price_purchase_margin_profit_amount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_purchase_margin_profit_amount == "number" ? itemData?.price_purchase_margin_profit_amount.toFixed(2) : itemData?.price_purchase_margin_profit_amount}
                                disabled={itemData?.price_purchase_margin_profit_percentage != 0}
                              />
                              {/* {errorMessage.price_purchase_margin_profit_amount && (
                              <FormText color="danger">{errorMessage.price_purchase_margin_profit_amount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_purchase_rate_approx" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Sale Rate Aprx.</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_purchase_rate_approx"
                                name="price_purchase_rate_approx"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_purchase_rate_approx == "number" ? itemData?.price_purchase_rate_approx.toFixed(2) : itemData?.price_purchase_rate_approx}
                              />
                              {/* {errorMessage.price_purchase_rate_approx && (
                              <FormText color="danger">{errorMessage.price_purchase_rate_approx}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>


                        </div>
                      </Col>
                      {/* </div> */}

                      {/* <div className="totals" style={{ float: 'right', width: '50%', paddingLeft: '10px' }}> */}
                      <Col xs="12" md="6" className="mb-3">


                        <div style={{ border: "2px solid black", padding: "10px", marginBottom: "10px", borderRadius: "20px", backgroundColor: "rgb(255 194 194)" }}>

                          <h4 style={{ fontWeight: "bold", margin: "10px 0 20px 0", textAlign: "center" }}>Sale Detail</h4>
                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_rate" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Sell Rate</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_rate"
                                name="price_sell_rate"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_sell_rate}
                              />
                              {/* {errorMessage.price_sell_rate && (
                              <FormText color="danger">{errorMessage.price_sell_rate}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_discount_percentage" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Discount %</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_discount_percentage"
                                name="price_sell_discount_percentage"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_sell_discount_percentage}
                              />
                              {/* {errorMessage.price_sell_discount_percentage && (
                              <FormText color="danger">{errorMessage.price_sell_discount_percentage}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>


                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_discount_amount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Discount Amt </Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_discount_amount"
                                name="price_sell_discount_amount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_sell_discount_amount == "number" ? itemData?.price_sell_discount_amount.toFixed(2) : itemData?.price_sell_discount_amount}

                                disabled

                              />
                              {/* {errorMessage.price_sell_discount_amount && (
                              <FormText color="danger">{errorMessage.price_sell_discount_amount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>


                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_amount_after_discount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Amount after discount</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_amount_after_discount"
                                name="price_sell_amount_after_discount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_sell_amount_after_discount == "number" ? itemData?.price_sell_amount_after_discount.toFixed(2) : itemData?.price_sell_amount_after_discount}
                                disabled
                              />
                              {/* {errorMessage.price_sell_amount_after_discount && (
                              <FormText color="danger">{errorMessage.price_sell_amount_after_discount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>


                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_gst_percentage" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>GST %</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_gst_percentage"
                                name="price_sell_gst_percentage"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={itemData?.price_sell_gst_percentage}
                              />
                              {/* {errorMessage.price_sell_gst_percentage && (
                              <FormText color="danger">{errorMessage.price_sell_gst_percentage}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_gst_amount" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>GST Amt</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_gst_amount"
                                name="price_sell_gst_amount"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_sell_gst_amount == "number" ? itemData?.price_sell_gst_amount.toFixed(2) : itemData?.price_sell_gst_amount}
                                disabled

                              />
                              {/* {errorMessage.price_sell_gst_amount && (
                              <FormText color="danger">{errorMessage.price_sell_gst_amount}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup style={{ display: "flex", textAlign: "center" }}>
                              <Label for="price_sell_amount_with_gst" style={{ width: "40%", marginRight: "10px", textAlign: "left" }}>Rate with Gst</Label>
                              <Input
                                style={{ width: "60%" }}
                                id="price_sell_amount_with_gst"
                                name="price_sell_amount_with_gst"
                                type="number"
                                onChange={(e) => { onChangeHandle(e) }}
                                value={typeof itemData?.price_sell_amount_with_gst == "number" ? itemData?.price_sell_amount_with_gst.toFixed(2) : itemData?.price_sell_amount_with_gst}
                              />
                              {/* {errorMessage.price_sell_amount_with_gst && (
                              <FormText color="danger">{errorMessage.price_sell_amount_with_gst}</FormText>
                            )} */}
                            </FormGroup>
                          </Col>
                        </div>

                      </Col>
                      {/* </div> */}

                    </Row>


                  </div>
                  {/* </Row>

                  </Form> */}
                </CardBody>
              </Collapse>
            </div>}


            {/* // Stock Detail  */}

            {registerMasterField?.item_acc_stock_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(5)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "blue" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Stock Detail
                </div>
                {openAccordion === 5 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}
              </CardTitle>

              <Collapse isOpen={openAccordion === 5}>


                <CardBody
                // style={{ backgroundColor: "rgb(179 179 238)" }}
                >
                  {/* <Form> */}


                  <Row>


                    <Col sm={12}>
                      <FormGroup >
                        <Label style={{ fontSize: 14 }} for="item_stock_location">Location Maintain Type</Label>
                        <Input
                          id="item_stock_location"
                          name="item_stock_location"
                          type="select" className="custom-select"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={stockDetail?.item_stock_location || ""}
                          style={{ fontSize: 14 }}
                        >
                          <option value="">Select</option>
                          {helperMasterLocation.length != 0 && helperMasterLocation.map((option) => (
                            <option key={option.id} value={option.field_data}>
                              {option.field_data}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      {stockErrorMessage.item_stock_location && (
                        <FormText color="danger">{stockErrorMessage.item_stock_location}</FormText>
                      )}
                    </Col>
                  </Row>
                  {/* <Col xs="12" sm="6" md="4" >
                        <FormGroup >
                          <Label style={{ fontSize: 14 }} for="item_stock_branch_location_id">Branch Name</Label>
                          <Input 
                            id="item_stock_branch_location_id"
                            name="item_stock_branch_location_id"
                            type="select"  className="custom-select"
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                            value={stockDetail?.item_stock_branch_location_id || ""}
                            style={{ fontSize: 14 }}
                          >
                            <option value="">Select</option>
                            {branchMaster.length != 0 && branchMaster.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.branch_name}
                              </option>
                            ))}
                          </Input>
                          {stockErrorMessage.item_stock_branch_location_id && (
                            <FormText color="danger">{stockErrorMessage.item_stock_branch_location_id}</FormText>
                          )}
                        </FormGroup>
                      </Col> */}

                  <Row>


                    <Col xs="12" sm="6" md="3" >
                      <FormGroup>
                        <Label style={{ fontSize: 14 }} for="item_stock_date">Opening Date</Label>
                        <Input
                          id="item_stock_date"
                          name="item_stock_date"
                          type="date"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={stockDetail?.item_stock_date || ""}
                          style={{ fontSize: 14 }}
                        />
                        {stockErrorMessage.item_stock_branch_location_id && (
                          <FormText color="danger">{stockErrorMessage.item_stock_branch_location_id}</FormText>
                        )}
                      </FormGroup>

                    </Col>
                    <Col xs="12" sm="6" md="3" >
                      <FormGroup>
                        <Label style={{ fontSize: 14 }} for="item_stock_qty">Opening Qty</Label>
                        <Input
                          type="number"
                          id="item_stock_qty"
                          name="item_stock_qty"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={stockDetail?.item_stock_qty || ""}
                          style={{ fontSize: 14 }}
                        />
                        {stockErrorMessage.item_stock_qty && (
                          <FormText color="danger">{stockErrorMessage.item_stock_qty}</FormText>
                        )}
                      </FormGroup>
                    </Col>
                    <Col xs="12" sm="6" md="3" >
                      <FormGroup>
                        <Label style={{ fontSize: 14 }} for="item_stock_rate"> Opening Rate</Label>
                        <Input
                          id="item_stock_rate"
                          name="item_stock_rate"
                          type="number"
                          min="0"
                          step="1"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={stockDetail?.item_stock_rate || ""}
                          style={{ fontSize: 14 }}
                        />
                        {stockErrorMessage.item_stock_rate && (
                          <FormText color="danger">{stockErrorMessage.item_stock_rate}</FormText>
                        )}
                      </FormGroup>
                    </Col>
                    <Col xs="12" sm="6" md="3" >
                      <FormGroup>
                        <Label style={{ fontSize: 14 }} for="item_stock_value">Opening Value of stock</Label>
                        <Input
                          id="item_stock_value"
                          name="item_stock_value"
                          type="telp"
                          min="0"
                          step="1"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={stockDetail?.item_stock_value || ""}
                          style={{ fontSize: 14 }}
                          disabled
                        />
                        {stockErrorMessage.item_stock_value && (
                          <FormText color="danger">{stockErrorMessage.item_stock_value}</FormText>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>

                    {registerMasterField?.batch_no === "yes" &&
                      <Col xs="12" sm="6" md="4" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_batch_no">Batch/Serial No</Label>
                          <Input
                            type="text"
                            name="item_batch_no"
                            id="item_batch_no"
                            value={stockDetail.item_batch_no}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />

                          {stockErrorMessage.item_batch_no && (
                            <FormText color="danger">{stockErrorMessage.item_batch_no}</FormText>
                          )}
                        </FormGroup>
                      </Col>

                    }

                    {registerMasterField?.style === "yes" &&
                      <Col xs="12" sm="6" md="2" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_style">Style</Label>
                          <Input
                            type="text"
                            name="item_style"
                            id="item_style"
                            value={stockDetail.item_style}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />
                          {stockErrorMessage.item_style && (
                            <FormText color="danger">{stockErrorMessage.item_style}</FormText>
                          )}
                        </FormGroup>
                      </Col>}

                    {registerMasterField?.brand === "yes" &&
                      <Col xs="12" sm="6" md="2" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_brand">Brand</Label>
                          <Input
                            type="text"
                            name="item_brand"
                            id="item_brand"
                            value={stockDetail.item_brand}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />
                          {stockErrorMessage.item_brand && (
                            <FormText color="danger">{stockErrorMessage.item_brand}</FormText>
                          )}
                        </FormGroup>
                      </Col>}

                    {registerMasterField?.color === "yes" &&
                      <Col xs="12" sm="6" md="2" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_color">Color</Label>
                          <Input
                            type="text"
                            name="item_color"
                            id="item_color"
                            value={stockDetail.item_color}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />

                          {stockErrorMessage.item_color && (
                            <FormText color="danger">{stockErrorMessage.item_color}</FormText>
                          )}
                        </FormGroup>
                      </Col>}




                    {(registerMasterField?.size === "yes" || true) &&
                      <Col xs="12" sm="6" md="2" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_size">Size</Label>
                          <Input
                            type="text"
                            name="item_size"
                            id="item_size"
                            value={stockDetail.item_size}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />

                          {stockErrorMessage.item_size && (
                            <FormText color="danger">{stockErrorMessage.item_size}</FormText>
                          )}
                        </FormGroup>
                      </Col>}

                  </Row>
                  <Row>


                    {registerMasterField?.agent === "yes" &&
                      <Col xs="12" sm="6" md="4" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_agent">Agent</Label>
                          <Input
                            type="text"
                            name="item_agent"
                            id="item_agent"
                            value={stockDetail.item_agent}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />
                          {stockErrorMessage.item_agent && (
                            <FormText color="danger">{stockErrorMessage.item_agent}</FormText>
                          )}
                        </FormGroup>
                      </Col>}
                    {registerMasterField?.dealer === "yes" &&
                      <Col xs="12" sm="6" md="4" >
                        <FormGroup>
                          <Label style={{ fontSize: 14 }} for="item_dealer">Dealer/Supplier </Label>
                          <Input
                            type="text"
                            name="item_dealer"
                            id="item_dealer"
                            value={stockDetail.item_dealer}
                            onChange={(e) => { onChangeStockDetailHandle(e) }}
                          />

                          {stockErrorMessage.item_dealer && (
                            <FormText color="danger">{stockErrorMessage.item_dealer}</FormText>
                          )}
                        </FormGroup>
                      </Col>}


                    <Col xs="12" sm="6" md="4" >
                      <Button type="button" style={{ backgroundColor: "#2962ff", color: "white", marginTop: 30 }} color="primary" onClick={() => AddStockDetail()}>
                        Save Detail
                      </Button>
                    </Col>


                    <Col sm={4}>
                      <FormGroup>
                        <Label for="total_stock">Overall Value of stock</Label>
                        <Input
                          id="total_stock"
                          name="total_stock"
                          type="number"
                          onChange={(e) => { onChangeStockDetailHandle(e) }}
                          value={itemData?.total_stock}
                          style={{ fontSize: 14 }}
                        />
                      </FormGroup>
                    </Col>


                  </Row>



                  {stockDetailArray.length != 0 &&
                    <>
                      <Table bordered responsive hover striped>
                        <thead>
                          <tr style={{ backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>ID</th>
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Location</th>
                            {/* <th style={{ padding: '10px', border: '1px solid #ddd' }}>Branch</th> */}
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Date</th>
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Qty</th>
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Rate</th>
                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Value of Stock</th>
                            {registerMasterField?.size === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Size</th>}
                            {registerMasterField?.batch_no === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Batch No/Serial No</th>}
                            {registerMasterField?.style === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Style</th>}
                            {registerMasterField?.brand === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Brand</th>}
                            {registerMasterField?.color === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Color</th>}
                            {registerMasterField?.agent === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Agent</th>}
                            {registerMasterField?.dealer === "yes" && <th style={{ padding: '10px', border: '1px solid #ddd' }}>Dealer</th>}

                            <th style={{ padding: '10px', border: '1px solid #ddd' }}>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stockDetailArray.map((item, index) => (
                            <tr key={index} style={{ textAlign: 'center' }}>
                              <th scope="row" style={{ padding: '10px', border: '1px solid #ddd' }}>{index + 1}</th>
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_location}</td>
                              {/* <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_branch_location}</td> */}
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_date}</td>
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_qty}</td>
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_rate}</td>
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_stock_value}</td>
                              {registerMasterField?.size === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.size}</td>}
                              {registerMasterField?.batch_no === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_batch_no}</td>}
                              {registerMasterField?.style === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_style}</td>}
                              {registerMasterField?.brand === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_brand}</td>}
                              {registerMasterField?.color === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_color}</td>}
                              {registerMasterField?.agent === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_agent}</td>}
                              {registerMasterField?.dealer === "yes" && <td style={{ padding: '10px', border: '1px solid #ddd' }}>{item.item_dealer}</td>}
                              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => RemoveStockDetail(index)}
                                >
                                  Delete
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  }

                </CardBody>

              </Collapse>
            </div>}

            {/* Batta Detail */}
            {registerMasterField?.item_acc_batta_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(6)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "orange" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Batta Detail
                </div>
                {openAccordion === 6 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}
              </CardTitle>

              <Collapse isOpen={openAccordion === 6}>
                <CardBody
                // style={{ backgroundColor: "rgb(179 179 238)" }}
                >

                  {/* Row 1 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="item_bag">Bag</Label>
                        <Input
                          id="item_bag"
                          name="item_bag"
                          type="text"
                          value={itemData?.item_bag}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="opening_balance">Opening Balance</Label>
                        <Input
                          id="opening_balance"
                          name="opening_balance"
                          type="text"
                          value={itemData?.opening_balance}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Row 2 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="kilograms">Kilograms</Label>
                        <Input
                          id="kilograms"
                          name="kilograms"
                          type="text"
                          value={itemData?.kilograms}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="value">Value</Label>
                        <Input
                          id="value"
                          name="value"
                          type="text"
                          value={itemData?.value}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Row 3 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="sale_rate_per">Sale Rate Per</Label>
                        <Input
                          id="sale_rate_per"
                          name="sale_rate_per"
                          type="text"
                          value={itemData?.sale_rate_per}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="purchase_rate_per">Purchase Rate Per</Label>
                        <Input
                          id="purchase_rate_per"
                          name="purchase_rate_per"
                          type="text"
                          value={itemData?.purchase_rate_per}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Row 4 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="kilograms_batta_per">Kilograms Batta %</Label>
                        <Input
                          id="kilograms_batta_per"
                          name="kilograms_batta_per"
                          type="text"
                          value={itemData?.kilograms_batta_per}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="bardana_rate">Bardana Rate</Label>
                        <Input
                          id="bardana_rate"
                          name="bardana_rate"
                          type="text"
                          value={itemData?.bardana_rate}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="bardana_weight">Bardana Weight</Label>
                        <Input
                          id="bardana_weight"
                          name="bardana_weight"
                          type="text"
                          value={itemData?.bardana_weight}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Row 5 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="misc_exp_per">Misc Exp %</Label>
                        <Input
                          id="misc_exp_per"
                          name="misc_exp_per"
                          type="text"
                          value={itemData?.misc_exp_per}
                          placeholder='0.00'
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Divider */}
                  <hr />
                  <h6 className="text-primary mb-3">Transfer In Item</h6>

                  {/* Row 6 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="standard_bharti">Standard Bharti</Label>
                        <Input
                          id="standard_bharti"
                          name="standard_bharti"
                          type="text"
                          value={itemData?.standard_bharti}
                          onKeyPress={allowOnlyNumberAndDot}
                          onPaste={allowOnlyNumberAndDotOnPaste}
                          onChange={onChangeHandle}
                          placeholder='0.00'
                        />
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="bharti_everytime">Bharti Everytime (Y/N)</Label>
                        <Input
                          id="bharti_everytime"
                          name="bharti_everytime"
                          type="select"
                          value={itemData?.bharti_everytime || "yes"}
                          onChange={onChangeHandle}
                          className='custom-select'
                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col sm={4}>
                      <FormGroup>
                        <Label for="ask_dhade">Ask Dhade (Y/N)</Label>
                        <Input
                          id="ask_dhade"
                          name="ask_dhade"
                          type="select"
                          value={itemData?.ask_dhade || "yes"}
                          onChange={onChangeHandle}
                          className='custom-select'

                        >
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Row 7 */}
                  <Row>
                    <Col sm={4}>
                      <FormGroup>
                        <Label for="k_ir_d_ry_oth">K-IR / D-RY / OTH</Label>
                        <Input
                          id="k_ir_d_ry_oth"
                          name="k_ir_d_ry_oth"
                          type="text"
                          value={itemData?.k_ir_d_ry_oth || ""}
                          onChange={onChangeHandle}
                        />
                      </FormGroup>
                    </Col>
                  </Row>


                </CardBody>
              </Collapse>
            </div>}


            {/* Remark Detail and Upload detail  */}

            {registerMasterField?.item_acc_remark_upload_yn == "yes" && <div>

              <RemarkPage

                // setRemarkDetail={setRemarkDetail}
                // remarkDetail={remarkDetail}
                fromName={"remark_detail_document_item"}
                openHelperModal={openHelperModal}

                remarkPageArrayList={remarkPageArrayList}
                setremarkPageArrayList={setremarkPageArrayList}

                deleteRemarkPageArrayList={deleteRemarkPageArrayList}
                setDeleteRemarkPageArrayList={setDeleteRemarkPageArrayList}

                helperMasterDocumentTypeTable={helperMasterDocumentTypeTable}
              />
            </div>}


            {/*  Item Multiple Image */}
            {registerMasterField?.item_acc_mul_image_yn == "yes" && <div>
              <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between"
                style={{ borderBottom: 'var(--bs-border-width) var(--bs-border-style) #000000' }}

                onClick={() => toggleAccordion(7)}>
                <div className="d-flex align-items-center" style={{ fontWeight: "bold", color: "purple" }}>
                  <i className="bi bi-bell mr-2"></i>
                  Item Multiple Image
                </div>
                {openAccordion === 7 ? <i className="bi bi-caret-up"></i> : <i className="bi bi-caret-down"></i>}
              </CardTitle>

              <Collapse isOpen={openAccordion === 7}>
                <CardBody>
                  <MultipleImageUpload

                    itemMulImgArrayList={itemMulImgArrayList}
                    setItemMulImgArrayList={setItemMulImgArrayList}

                    deleteItemMulImgArrayList={deleteItemMulImgArrayList}
                    setDeleteItemMulImgArrayList={setDeleteItemMulImgArrayList}
                  />

                </CardBody>
              </Collapse>
            </div>}


            {/* Error Model */}

            <ErrorModal
              show={showErrorModal}
              title="Validation / Action Required"
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
            // onConfirm={true}
            />


            {/* Model */}
            {/* //================================================================= */}
            <CustomerAddHelperMaster show={showHelperModal} fromName={fromName} closedModel={closedHelperModal}
              fetchHelperData={fetchHelperData}

              vendormasterId={itemData.item_branch_vendor_id}
              branchMasterId={itemData.item_branch_master_id}
              helperMasterWorkBussinessTable={helperMasterWorkBussinessTable}

            />




          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AddItem;






